// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Gentelella shell: full-width (Bootstrap .container would otherwise cap width) */
.container.body {
  max-width: 100% !important;
  width: 100%;
  margin-left: 0;
  margin-right: 0;
  padding-left: 0;
  padding-right: 0;
}

/* Gentelella-style admin: collapsed sidebar shows icons only (complements public/admin/css/style.css) */
body.nav-sm .nav.side-menu > li > a {
  font-size: 0;
  line-height: 0;
}

body.nav-sm .nav.side-menu > li > a i {
  font-size: 20px !important;
  line-height: 1.3 !important;
  display: block;
  margin: 0 auto 4px;
}

#menu_toggle {
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 2.25rem;
  min-height: 2.25rem;
  border: none;
  background: transparent;
  color: inherit;
  border-radius: 6px;
  transition: background 0.2s ease, transform 0.2s ease;
}

#menu_toggle:hover {
  background: rgba(0, 0, 0, 0.05);
}

html.dark #menu_toggle:hover {
  background: rgba(255, 255, 255, 0.08);
}

#menu_toggle i {
  font-size: 1.1rem;
}

/* Point chevron: expanded = “collapse” (inward), collapsed = “expand” (outward) */
body.nav-md #menu_toggle .admin-menu-chevron {
  transform: rotate(0deg);
}

body.nav-sm #menu_toggle .admin-menu-chevron {
  transform: rotate(180deg);
}

/* Admin rich-text editors (ReactQuill with the form-control class): full content visible.
   form-control fixed the editor to one input row, hiding all but the last line. */
.right_col .quill.form-control {
  height: auto;
  padding: 0;
  border: none;
  background: transparent;
}
.right_col .quill .ql-toolbar.ql-snow { border-radius: 8px 8px 0 0; }
.right_col .quill .ql-container.ql-snow {
  height: auto;
  border-radius: 0 0 8px 8px;
  font-size: 16px;
}
.right_col .quill .ql-editor {
  min-height: 320px;
  max-height: 65vh;
  overflow-y: auto;
  line-height: 1.6;
}
`, "",{"version":3,"sources":["webpack://./src/component/admin/admin-layout.css"],"names":[],"mappings":"AAAA,kFAAkF;AAClF;EACE,0BAA0B;EAC1B,WAAW;EACX,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA,wGAAwG;AACxG;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,qDAAqD;AACvD;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,iBAAiB;AACnB;;AAEA,kFAAkF;AAClF;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;kFACkF;AAClF;EACE,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,uBAAuB;AACzB;AACA,wCAAwC,0BAA0B,EAAE;AACpE;EACE,YAAY;EACZ,0BAA0B;EAC1B,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB","sourcesContent":["/* Gentelella shell: full-width (Bootstrap .container would otherwise cap width) */\n.container.body {\n  max-width: 100% !important;\n  width: 100%;\n  margin-left: 0;\n  margin-right: 0;\n  padding-left: 0;\n  padding-right: 0;\n}\n\n/* Gentelella-style admin: collapsed sidebar shows icons only (complements public/admin/css/style.css) */\nbody.nav-sm .nav.side-menu > li > a {\n  font-size: 0;\n  line-height: 0;\n}\n\nbody.nav-sm .nav.side-menu > li > a i {\n  font-size: 20px !important;\n  line-height: 1.3 !important;\n  display: block;\n  margin: 0 auto 4px;\n}\n\n#menu_toggle {\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 2.25rem;\n  min-height: 2.25rem;\n  border: none;\n  background: transparent;\n  color: inherit;\n  border-radius: 6px;\n  transition: background 0.2s ease, transform 0.2s ease;\n}\n\n#menu_toggle:hover {\n  background: rgba(0, 0, 0, 0.05);\n}\n\nhtml.dark #menu_toggle:hover {\n  background: rgba(255, 255, 255, 0.08);\n}\n\n#menu_toggle i {\n  font-size: 1.1rem;\n}\n\n/* Point chevron: expanded = “collapse” (inward), collapsed = “expand” (outward) */\nbody.nav-md #menu_toggle .admin-menu-chevron {\n  transform: rotate(0deg);\n}\n\nbody.nav-sm #menu_toggle .admin-menu-chevron {\n  transform: rotate(180deg);\n}\n\n/* Admin rich-text editors (ReactQuill with the form-control class): full content visible.\n   form-control fixed the editor to one input row, hiding all but the last line. */\n.right_col .quill.form-control {\n  height: auto;\n  padding: 0;\n  border: none;\n  background: transparent;\n}\n.right_col .quill .ql-toolbar.ql-snow { border-radius: 8px 8px 0 0; }\n.right_col .quill .ql-container.ql-snow {\n  height: auto;\n  border-radius: 0 0 8px 8px;\n  font-size: 16px;\n}\n.right_col .quill .ql-editor {\n  min-height: 320px;\n  max-height: 65vh;\n  overflow-y: auto;\n  line-height: 1.6;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
